import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { LocationMetricInfo } from 'owa-calendar-helpers-types/lib/LocationMetricTypes';
import {
    createLocationMetricsFromEnhancedLocation,
    getLocationMetricId,
} from 'owa-calendar-helpers-types/lib/utils/createLocationMetrics';
import { logUsage } from 'owa-analytics';

export default function logLocationMetrics(
    event: CalendarEvent,
    formSessionId: string,
    locationMetrics: { [index: string]: LocationMetricInfo }
) {
    if (event.Locations) {
        event.Locations.forEach(location => {
            const locationId = getLocationMetricId(location.Id, location.PostalAddress);
            if (locationMetrics[locationId]) {
                logLocationMetric(formSessionId, locationMetrics[locationId]);
            } else {
                // Log locations added from other sources such as add-ins as Other
                logLocationMetric(
                    formSessionId,
                    createLocationMetricsFromEnhancedLocation(location, 'Other')
                );
            }
        });
    }
}

function logLocationMetric(formSessionId: string, metric: LocationMetricInfo) {
    logUsage(
        'SavedEventLocation',
        {
            formSessionId: formSessionId,
            ...metric,
        },
        {
            isCore: true,
        }
    );
}
